import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 31.7",
  "description": "",
  "published": "2011-07-31T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-31-7/swizec/2040"],
  "categories": "Environment, Hawaii, Learning, Personal, Surfing, Water",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/300px-Mavericks_Surf_Contest_2010b3.jpg",
        "alt": "Mavericks Surf Contest 2010.",
        "title": "Mavericks Surf Contest 2010."
      }}></img></p>
    <p>{`Today I got a small glimpse into what makes `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Surfing",
        "title": "Surfing"
      }}>{`surfers`}</a>{` do all the crazy things that they do. You know, like the getting up at 3am, just to drive for a couple of hours to go sit still in freezing water for an hour or two and get a compound two minutes of fun time out of it and perhaps ten seconds of perfect fun time.`}</p>
    <p>{`Crazy bastards.`}</p>
    <p>{`I did something similar. Swam in the ocean and the feeling you get when the waves are churning you around is just divine. Even though the water is freezing and I didn't even have a wetsuit ... totally worth it. Now I want to go try sitting around in the water on a floating plank.`}</p>
    <p>{`Another thing that I learned is that surfing originates from Hawaii and there are records of it being standard practice as early as the 16th century. It started gaining popularity outside Hawaii (defined as inside US in the surfing museum) in the early 20th century. The boards they used back then were right scary. Big fat wooden things that seem to weight a ton.`}</p>
    <p>{`I wouldn't even dream of trying to surf with those.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/2037/swizec/2037"
        }}>{`I learned two things today 30.7.`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/i-learned-two-things-today-29-7/swizec/2022"
        }}>{`I learned two things today 29.7.`}</a>{` (swizec.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=01a6e7d0-ba96-4b7c-88a8-2a9da497869c",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      